<form #form="ngForm">
    <div class="app-grid">
        <p
            class="columns-12 description"
            [innerHTML]="
                'time-off-v3.thisWillReassignAllEmployeesCurrentlyOnSource'
                    | translate: { policyName: sourcePolicy?.name }
                    | sanitizeHtml
            "
        ></p>
        <mat-form-field class="columns-6">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.reassignToPolicy' | translate }}</mat-label>
            <mat-select
                name="policies"
                [(ngModel)]="selectPolicy"
                placeholder="{{ 'time-off-v3.selectTimeOffPolicy' | translate }}"
            >
                <mat-option *ngFor="let policy of policies" [value]="policy.id">
                    <span>{{ policy.name }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="columns-12 app-grid">
            <mat-form-field class="columns-6">
                <mat-label appRemoveAriaOwns>{{ 'time-off-v3.effectiveDate' | translate }}</mat-label>
                <mat-select name="effectiveDates" [(ngModel)]="effectiveAtType" #targetPolicy>
                    <mat-option *ngFor="let effectiveAtOption of effectiveAtOptions" [value]="effectiveAtOption.value">
                        <span>{{ effectiveAtOption.label | appTranslate }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="isCustomDate" class="columns-6">
                <input
                    [(ngModel)]="effectiveAt"
                    [matDatepicker]="accrualStartDatePicker"
                    name="accrualDatePickerInput"
                    #accrualDatePickerInput="ngModel"
                    matInput
                    required
                />
                <mat-datepicker-toggle matSuffix [for]="accrualStartDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #accrualStartDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</form>
